import { render } from "./Access_denied.vue?vue&type=template&id=efe05c1a&scoped=true"
import script from "./Access_denied.vue?vue&type=script&lang=js"
export * from "./Access_denied.vue?vue&type=script&lang=js"

import "./Access_denied.vue?vue&type=style&index=0&id=efe05c1a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-efe05c1a"]])

export default __exports__